import TopSalesPerformers from '../TopSalesPerformers';

interface IOperationsSubRBaseLayoutProps {
  widget: string | undefined;
}

const OperationsSubRBaseLayout = ({ widget }: IOperationsSubRBaseLayoutProps) => {
  switch (widget) {
    case 'top-sales-performers':
      return <TopSalesPerformers />;
    default:
      return null;
  }
};

export default OperationsSubRBaseLayout;
